import styles from "./debito.module.css";
import pdf from "../../files/Planilla_Pago_Directo.pdf";
import { Button, IconButton, styled, TextField } from "@mui/material";
import ApiFetch from "../../utils/fetch";
import Modal from "../../components/modal/modalCenter";
import { useContext, useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Swal from "sweetalert2";
import Loading from "../../components/loading/loading";
import TitlePage from "../../components/titlePage/titlePage";
import { AppContext } from "../../context/context";
import inputControl from "../../utils/inputControl";
import UpdateProfile from "../../components/updateProfile/updateProfile";
import ReturnBackButton from "../../components/returnBackButton/ReturnBackButton";

const fetch = new ApiFetch();

const Debito = () => {
  const { sessionExpired } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [nroTelefono, setNroTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [validateEmail, setValidateEmail] = useState(false);
  const [filePdf, setFilePdf] = useState("");
  const [loading, setLoading] = useState("");

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const successUploadAlert = (text) => {
    Swal.fire({
      icon: "success",
      text: text,
    });
  };

  const warningUploadAlert = (text) => {
    Swal.fire({
      icon: "warning",
      text: text,
    });
  };

  const errorUploadAlert = (text) => {
    Swal.fire({
      icon: "error",
      text: text,
    });
  };

  const handleChangeFiles = (e) => {
    try {
      const file = e.target.files[0];
      const validExtensions = [".pdf"];
      const fileExtension = file?.name.split(".").pop().toLowerCase();

      if (validExtensions.includes(`.${fileExtension}`)) {
        setFilePdf(file);
      } else {
        Swal.fire({
          text: "Solo se pueden cargar archivos con extensión .pdf",
          icon: "warning",
          confirmButtonText: "Ok",
          confirmButtonColor: "#ffb700",
          backdrop: "rgb(255, 165, 0, 0.20)",
        });
      }
    } catch (error) {
      Swal.fire({
        text: "Hubo un error al intentar cargar el archivo, por favor intente nuevamente.",
        icon: "error",
      });
    }
  };

  const send = async () => {
    try {
      if (!nroTelefono || !filePdf || !email || !validateEmail) {
        warningUploadAlert("Debe cargar todos los datos solicitados.");
        return;
      }
      const formData = new FormData();
      formData.append("nroTelefono", nroTelefono);
      formData.append("email", email);
      formData.append("pdfDebito", filePdf);
      setLoading(<Loading />);
      const data = await fetch.POST_FORMDATA(formData, `/debito`);
      setLoading("");
      const status = data?.status;
      const message = data?.message;

      switch (status) {
        case 200:
          setShowModal(false);
          setEmail("");
          setValidateEmail(false);
          setNroTelefono("");
          setFilePdf("");
          successUploadAlert(message);
          break;
        case 401:
          sessionExpired(message);
          break;

        default:
          errorUploadAlert(message);
          break;
      }
    } catch (error) {
      setLoading("");
      errorUploadAlert(
        "Hubo un error al enviar la solicitud, por favor intente nuevamente más tarde.",
      );
    }
  };

  const handleChange = (e, setStatus, max) => {
    const value = e.target.value;
    if ((value >= 0 || value <= 9) && value.length <= max) {
      setStatus(value);
    }
  };

  const handleChangeEmail = (e, setStatus) => {
    const value = e.target.value;
    const validate = inputControl.email(value);
    if (!validate && value.length > 0) {
      setValidateEmail(false);
    } else {
      setValidateEmail(true);
    }
    setStatus(value);
  };

  return (
    <div className={styles.container}>
      <ReturnBackButton />
      <TitlePage idTramite={8} />
      <div className={styles.stepContainer}>
        <span className={styles.step}>
          <b>Paso 1:</b> Descargue el formulario de solicitud y complete con los
          datos requeridos.
          <a href={pdf} download>
            <Button color="info" size="small" variant="contained">
              Descargar
            </Button>
          </a>
        </span>
        <span className={styles.step}>
          <b>Paso 2:</b> Una vez completado el formulario, suba el mismo en
          formato PDF.
          <Button
            onClick={() => setShowModal(true)}
            size="small"
            variant="contained"
            color="info"
          >
            Subir Pdf
          </Button>{" "}
        </span>
      </div>
      <Modal
        size="small"
        show={showModal}
        setShow={setShowModal}
        title="Enviar solicitud"
      >
        <div className={styles.inputsContainer}>
          <TextField
            helperText="Ingrese código de área seguido de su número SIN 15."
            value={nroTelefono}
            onChange={(e) => handleChange(e, setNroTelefono, 11)}
            size="small"
            label="Nro de Teléfono"
          />
          <TextField
            error={validateEmail ? false : true}
            helperText={!validateEmail && "El correo electrónico no es válido."}
            value={email}
            onChange={(e) => handleChangeEmail(e, setEmail)}
            size="small"
            label="Correo Electrónico"
          />

          <div className={styles.uploadPdfContainer}>
            <span style={{ color: filePdf ? "green" : "black" }}>
              {filePdf ? "pdf subido con éxito" : "subir pdf"}
            </span>
            <IconButton
              className={styles.button}
              color={filePdf ? "success" : "inherit"}
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
            >
              <CloudUploadIcon />
              <VisuallyHiddenInput
                type="file"
                accept=".pdf"
                onChange={(e) => handleChangeFiles(e)}
              />
            </IconButton>
          </div>
          <hr></hr>
          <div className={styles.footerButtonModal}>
            <Button
              onClick={() => setShowModal(false)}
              size="small"
              variant="text"
              color="inherit"
            >
              Cancelar
            </Button>
            <Button
              onClick={() => send()}
              size="small"
              variant="contained"
              color="success"
            >
              Enviar
            </Button>
          </div>
        </div>
      </Modal>
      {/* <UpdateProfile /> */}
      {loading}
    </div>
  );
};

export default Debito;
